require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/fn/symbol/index.js
// module id = 166
// module chunks = 5 6 7 9 10 12 13 14 16 17 18 20 21 22 23 24 25 27